module.exports = __webpack_public_path__ + "cd42ac32438cc2b5ea26c7d25f7c3847.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-facebook-grey.svg
// module id = iVZy
// module chunks = 5